<template>
  <div class="w-100">
    <h3 class="mb-3" v-once>Dataset</h3>
    <span v-once
      >Silahkan memilih salah satu Dataset yang tersedia di bawah</span
    >
    <div v-show="originalIsCategoryNextClicked">
      <b-skeleton-wrapper :loading="loadingDatasetInput">
        <b-row class="mt-2 mx-0" align-v="center">
          <b-col class="p-0" cols="5">
            <b-skeleton type="input"></b-skeleton>
          </b-col>
          <b-col
            v-for="val in 2"
            :key="val"
            class="p-0"
            cols="1"
            style="display: flex !important; justify-content: center !important"
          >
            <b-skeleton type="button"></b-skeleton>
          </b-col>
        </b-row>
      </b-skeleton-wrapper>
    </div>

    <b-form
      class="form-group-tabel-dinamis mt-2 py-0"
      v-show="loadingDatasetInput"
      inline
    >
      <div
        class="mt-2"
        v-show="optionsDataset.length < 1"
        style="font-style: italic"
      >
        ---Mohon maaf sebelumnya, dataset yang diinginkan belum tersedia untuk
        saat ini---
      </div>

      <b-form-select
        class="mr-1"
        v-model="selectedDataset"
        :select-size="1"
        style="width: 50%"
        v-show="optionsDataset.length > 0"
        :disabled="isLoadingAnOptions || isEditSelectedData"
      >
        <template #first>
          <b-form-select-option :value="null" disabled
            >-- Please select an option --</b-form-select-option
          >
        </template>

        <b-form-select-option
          v-for="option_dataset in optionsDataset"
          :value="option_dataset"
          :key="option_dataset.id"
          :title="option_dataset.name"
          >{{ option_dataset.name }}</b-form-select-option
        >
      </b-form-select>

      <b-button
        class="ml-1 td-btn-teal"
        v-show="optionsDataset.length > 0"
        @click="isDatasetMetadata = !isDatasetMetadata"
        style="height: 34px !important"
      >
        <b-icon icon="tags" />
        <template v-if="!isDatasetMetadata"> Lihat</template>
        <template v-else> Tutup </template>
        Metadata</b-button
      >

      <b-button
        class="mx-1 td-btn-blue"
        v-show="optionsDataset.length > 0"
        @click="nextRegularToCategory()"
        title="Kembali ke opsi subjek"
        style="height: 34px !important"
        ><b-icon icon="chevron-double-left" /> Kembali</b-button
      >

      <b-button
        class="td-btn-blue"
        :disabled="
          selectedDataset == null || isLoadingAnOptions || isEditSelectedData
        "
        v-show="optionsDataset.length > 0"
        @click="nextToIndicator()"
        title="Melanjutkan ke opsi indicator"
        style="height: 34px !important"
        >Lanjut <b-icon icon="chevron-double-right"
      /></b-button>
    </b-form>

    <transition name="td-slide">
      <div class="mt-4" v-show="isDatasetMetadata">
        <b-row>
          <b-col>
            <h6 class="m-0">Metadata Dataset</h6>
          </b-col>
        </b-row>

        <b-row class="mt-2">
          <b-col>
            <b-icon icon="bookmarks-fill" />
            <span class="font-weight-bold ml-1">Dataset</span>
          </b-col>
        </b-row>

        <b-row>
          <b-col class="ml-4" cols="10">
            <span class="font-weight-bolder" style="font-size: 0.75rem"
              >{{ selectedDatasetName }}
            </span>
          </b-col>
        </b-row>

        <b-row class="mt-2">
          <b-col>
            <b-icon icon="calendar2-week" />
            <span class="font-weight-bold ml-1">Frekuensi</span>
          </b-col>
        </b-row>

        <b-row>
          <b-col class="ml-4" cols="10">
            <span style="font-size: 0.75rem"
              >{{ selectedDatasetFrequency }}
            </span>
          </b-col>
        </b-row>

        <b-row class="mt-2">
          <b-col>
            <b-icon icon="puzzle-fill" />
            <span class="font-weight-bold ml-1">Jenis Data</span>
          </b-col>
        </b-row>

        <b-row>
          <b-col class="ml-4" cols="10">
            <span style="font-size: 0.75rem"
              >{{ selectedDatasetDataType }}
            </span>
          </b-col>
        </b-row>

        <b-row class="mt-2">
          <b-col>
            <b-icon icon="building" />
            <span class="font-weight-bold ml-1">Pemilik Data</span>
          </b-col>
        </b-row>

        <b-row>
          <b-col class="ml-4" cols="10">
            <span style="font-size: 0.75rem">{{ selectedDatasetOwner }} </span>
          </b-col>
        </b-row>

        <b-row class="mt-2">
          <b-col>
            <b-icon icon="people-fill" />
            <span class="font-weight-bold ml-1">Divisi Pengelola Data</span>
          </b-col>
        </b-row>

        <b-row>
          <b-col class="ml-4" cols="10">
            <span style="font-size: 0.75rem"
              >{{ selectedDatasetMaintainer }}
            </span>
          </b-col>
        </b-row>
      </div>
    </transition>
  </div>
</template>

<!-- javascript section-->
<script>
//import js modules section
import services from "../../../../../services/TabelDinamisServicesV3";
import utils from "../../../../../utils/TabelDinamisUtils.js";
import store from "../../../../../store/TabelDinamisStoreV3.js";

//local registration for output component
export default {
  name: "DatasetSelection",
  data() {
    return {
      isDatasetMetadata: false,
      isDatasetNextClicked: false,
      optionsDataset: "",
      selectedDataset: null,
      selectedDatasetName: "-",
      selectedDatasetFrequency: "-",
      selectedDatasetDataType: "-",
      selectedDatasetOwner: "-",
      selectedDatasetMaintainer: "-",
    };
  },
  props: [
    "projectName",
    "originalOptionsDataset",
    "originalSelectedDataset",
    "originalIsDatasetNextClicked",
    "originalIsCategoryNextClicked",
    "categoryName",
    "categoryId",
    "isLoadingAnOptions",
    "isEditSelectedData",
    "idxSelectedData",
  ],
  created() {},
  destroyed() {},
  mounted: function () {},
  computed: {
    loadingDatasetInput: function () {
      if (this.optionsDataset === "") {
        return false;
      } else {
        return true;
      }
    },
  },
  watch: {
    selectedDataset: {
      handler: function (val) {
        if (val == null) {
          this.selectedDatasetName = "-";
          this.selectedDatasetFrequency = "-";
          this.selectedDatasetDataType = "-";
          this.selectedDatasetOwner = "-";
          this.selectedDatasetMaintainer = "-";
        } else {
          this.selectedDatasetName = utils.changeNullIntoStrip(
            this.selectedDataset.name
          );
          this.selectedDatasetFrequency = utils.changeNullIntoStrip(
            this.selectedDataset.frequency
          );
          this.selectedDatasetDataType = utils.changeNullIntoStrip(
            this.selectedDataset.dataType
          );
          this.selectedDatasetOwner = utils.changeNullIntoStrip(
            this.selectedDataset.owner
          );
          this.selectedDatasetMaintainer = utils.changeNullIntoStrip(
            this.selectedDataset.maintainer
          );

          if (!this.isEditSelectedData) {
            this.isDatasetNextClicked = false;
          }

          this.$emit("update:originalSelectedDataset", val);
        }
      },
      immediate: true,
    },
    optionsDataset: {
      handler: function (newVal, oldVal) {
        if (newVal !== oldVal) {
          this.$emit("update:originalOptionsDataset", newVal);
        }
      },
      immediate: true,
    },
    originalIsCategoryNextClicked: {
      handler: function (val) {
        // console.log("sandy");
        // console.log(val);
        // console.log(this.categoryName);
        if (val) {
          this.$emit("update:isLoadingAnOptions", true);

          let statusDatasetOptionsLocalStorage =
            store.precheckDatasetOptionsLocalStorage(this.categoryId);

          switch (statusDatasetOptionsLocalStorage) {
            case "expired":
            case "not-set":
              this.loadDatasetByCategory(this.categoryName, this.projectName);
              break;
            case "alive":
              setTimeout(
                function () {
                  this.optionsDataset = JSON.parse(
                    store.getSelectionLocalStorageByKey("dataset")
                  ).find((item) => item.categoryId === this.categoryId).items;

                  if (this.isEditSelectedData) {
                    let selectedDataList =
                      store.getSelectedDataListLocalStorageByCurrentUsername();

                    this.selectedDataset =
                      selectedDataList[0].items[
                        this.idxSelectedData
                      ].selectedDataset;

                    this.nextToIndicator();
                  }

                  this.$emit("update:isLoadingAnOptions", false);
                }.bind(this),
                200
              );

              break;
          }
        } else {
          this.optionsDataset = "";
          this.selectedDataset = null;
          this.isDatasetMetadata = false;
          this.isDatasetNextClicked = false;
        }
      },
      immediate: true,
    },
    isDatasetNextClicked: {
      handler: function (newVal, oldVal) {
        if (newVal !== oldVal) {
          this.$emit(
            "update:originalIsDatasetNextClicked",
            this.isDatasetNextClicked
          );
        }
      },
      immediate: true,
    },
    originalSelectedDataset: {
      handler: function (newVal, oldVal) {
        if (newVal !== oldVal) {
          this.selectedDataset = newVal;
        }
      },
      immediate: true,
    },
    originalOptionsDataset: {
      handler: function (newVal, oldVal) {
        if (newVal !== oldVal) {
          this.optionsDataset = newVal;
        }
      },
    },
  },
  methods: {
    async loadDatasetByCategory(category, project) {
      await services.getDatasetByCategoryAndProject(category, project).then(
        (response) => {
          this.optionsDataset = response.data.data.datasetList;
          utils.sortArrayByStringProperty(this.optionsDataset, "name");
          store.updateSelectionLocalStorage("dataset", this.optionsDataset, {
            categoryName: this.categoryName,
            categoryId: this.categoryId,
          });

          if (this.isEditSelectedData) {
            let selectedDataList =
              store.getSelectedDataListLocalStorageByCurrentUsername();

            this.selectedDataset =
              selectedDataList[0].items[this.idxSelectedData].selectedDataset;

            this.nextToIndicator();
          }

          this.$emit("update:isLoadingAnOptions", false);
        },
        (error) => {
          if (error.response.data.errors[0].code === "td-err.subject.001") {
            this.optionsDataset = [];
          }

          this.$emit("update:isLoadingAnOptions", false);
        }
      );
    },
    nextToIndicator() {
      if (this.selectedDataset != null) {
        utils.scrollIntoDiv("tabel-dinamis-progress-stepper-indicator");
        this.isDatasetNextClicked = true;
      }
    },
    nextRegularCategory() {
      utils.scrollIntoDiv("tabel-dinamis-progress-stepper-category");
    },
  },
  components: {},
};
</script>

<!-- css section-->
<style lang="scss" scoped>
@import "src/assets/scss/_table-dinamis";
</style>

<!-- author: m.hanif.fahyuananto-->
<!-- version 3.0.0 -->
<!-- created on 25-04-2022 -->
